import { ComponentChildren, JSX } from 'preact'
import { BlockTreeContext, BlockTreeContextValue } from './BlockTreeContext'
import { DEFAULT_BLOCK_MAPPING } from './mapping'

interface Props {
  value?: BlockTreeContextValue
  children: ComponentChildren
}

export function BlockTreeProvider({ children, value = DEFAULT_BLOCK_MAPPING }: Props): JSX.Element {
  return <BlockTreeContext.Provider value={value}>{children}</BlockTreeContext.Provider>
}
